import { jsxs as _jsxs } from "react/jsx-runtime";
import { StyledText } from '../../../styles/text';
import useDeviceWidth from '../../../hooks/use-device-width';
var SkuReferenceDetails = function (_a) {
    var referenceDetails = _a.referenceDetails, children = _a.children;
    var isMobile = useDeviceWidth();
    return (_jsxs(StyledText, { size: isMobile ? 'regular' : 'root', lineHeight: 1.5, children: [referenceDetails === null || referenceDetails === void 0 ? void 0 : referenceDetails.join(', '), children] }));
};
export default SkuReferenceDetails;
//# sourceMappingURL=index.js.map